import type { AgentGroup } from "@/resources/agentGroup";
import type { Filter } from "@/utils/apiFilter";
import { apiClient } from "./apiClient";

class AgentGroupService {
  async list(filter: Filter = {}): Promise<AgentGroup[]> {
    try {
      const response = await apiClient.get<AgentGroup[]>("/agent-groups", {
        ...filter,
        limit: 1000,
      });
      if (response.status === "OK" && response.result) {
        return response.result;
      }
      console.warn(
        "AgentGroup API returned unexpected status:",
        response.status,
      );
      return [];
    } catch (error) {
      console.error("Error fetching agentGroup:", error);
      return [];
    }
  }
}

export const agentGroupService = new AgentGroupService();
